import _regeneratorRuntime from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _slicedToArray from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/slicedToArray.js";
import _asyncToGenerator from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/home/vsts/work/1/s/client/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.sticky.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.number.constructor.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.object.from-entries.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import MasterDataTable from './MasterDataTable.vue';
import { getMasterDataApi, importMasterDataApi } from '@/api/selfAnalysis';

/** 主鍵與串列編號由 05 帶，其餘常填同值的欄位整批套 */
var FROM_MAP = ['site_code', 'inv_index', 'string_index', 'string_id'];
export default {
  name: 'StringDesignPanel',
  components: {
    MasterDataTable: MasterDataTable
  },
  props: {
    def: {
      type: Object,
      required: true
    },
    siteCode: {
      type: String,
      default: ''
    }
  },
  data: function data() {
    return {
      open: false,
      loading: false,
      saving: false,
      /** 05 裡有接的列 */
      map: [],
      existing: 0,
      spec: {},
      loadError: '',
      error: ''
    };
  },
  computed: {
    specColumns: function specColumns() {
      return this.def.columns.filter(function (c) {
        return c.sticky && !c.readonly && !FROM_MAP.includes(c.name);
      });
    },
    rows: function rows() {
      var _this = this;
      return this.map.map(function (r) {
        return _objectSpread({
          site_code: _this.siteCode,
          inv_index: r.inv_index,
          string_index: r.string_index,
          string_id: r.string_id
        }, _this.spec);
      });
    },
    capacity: function capacity() {
      var kwp = Number(this.spec.module_watt_w) * Number(this.spec.modules_in_series) / 1000;
      return kwp > 0 ? +kwp.toFixed(3) : 0;
    }
  },
  methods: {
    onShow: function onShow() {
      var _this2 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        var last, _yield$Promise$all, _yield$Promise$all2, map, mine;
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                _this2.error = '';
                _this2.loadError = '';
                _this2.map = [];
                _this2.existing = 0;
                // 表格裡最後一列的規格先帶上，第二個案場以後通常只差幾欄
                last = _this2.$refs.table.rows[_this2.$refs.table.rows.length - 1] || {};
                _this2.spec = Object.fromEntries(_this2.specColumns.map(function (c) {
                  var _last$c$name;
                  return [c.name, (_last$c$name = last[c.name]) !== null && _last$c$name !== void 0 ? _last$c$name : null];
                }));
                _this2.loading = true;
                _context.prev = 7;
                _context.next = 10;
                return Promise.all([getMasterDataApi('mppt_string_map', _this2.siteCode), getMasterDataApi('string_design', _this2.siteCode)]);
              case 10:
                _yield$Promise$all = _context.sent;
                _yield$Promise$all2 = _slicedToArray(_yield$Promise$all, 2);
                map = _yield$Promise$all2[0];
                mine = _yield$Promise$all2[1];
                // 串列編號留空 = 空接，那格沒有模組，不建 06
                _this2.map = (map.data || []).filter(function (r) {
                  return r.string_id;
                });
                _this2.existing = (mine.data || []).length;
                _context.next = 21;
                break;
              case 18:
                _context.prev = 18;
                _context.t0 = _context["catch"](7);
                _this2.loadError = (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.msg) || (_context.t0 === null || _context.t0 === void 0 ? void 0 : _context.t0.message) || '無法讀取 MPPT串列對應資料';
              case 21:
                _context.prev = 21;
                _this2.loading = false;
                return _context.finish(21);
              case 24:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[7, 18, 21, 24]]);
      }))();
    },
    save: function save() {
      var _this3 = this;
      return _asyncToGenerator(/*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var res;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _this3.saving = true;
                _this3.error = '';
                _context2.prev = 2;
                _context2.next = 5;
                return importMasterDataApi('string_design', _this3.rows);
              case 5:
                res = _context2.sent;
                _this3.$swal(res.msg || '已寫入');
                _this3.open = false;
                _this3.$refs.table.load();
                _this3.$emit('changed');
                _context2.next = 15;
                break;
              case 12:
                _context2.prev = 12;
                _context2.t0 = _context2["catch"](2);
                _this3.error = (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.msg) || (_context2.t0 === null || _context2.t0 === void 0 ? void 0 : _context2.t0.message) || '寫入失敗';
              case 15:
                _context2.prev = 15;
                _this3.saving = false;
                return _context2.finish(15);
              case 18:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, null, [[2, 12, 15, 18]]);
      }))();
    }
  }
};